import React, { useState } from 'react';

const screenshots = [
  { src: require('../assets/screenshots/screen1.png'), alt: 'Beanbag app screenshot 1' },
  { src: require('../assets/screenshots/screen2.png'), alt: 'Beanbag app screenshot 2' },
  { src: require('../assets/screenshots/screen3.png'), alt: 'Beanbag app screenshot 3' },
  { src: require('../assets/screenshots/screen4.png'), alt: 'Beanbag app screenshot 4' },
  { src: require('../assets/screenshots/screen5.png'), alt: 'Beanbag app screenshot 5' },
];

const ScreenshotCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const changeSlide = (newIndex) => {
    setCurrentIndex(newIndex);
  };

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? screenshots.length - 1 : currentIndex - 1;
    changeSlide(newIndex);
  };

  const goToNext = () => {
    const newIndex = currentIndex === screenshots.length - 1 ? 0 : currentIndex + 1;
    changeSlide(newIndex);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center justify-center gap-4">
        {/* Previous Button */}
        <button
          onClick={goToPrevious}
          className="btn btn-circle btn-outline btn-sm flex-shrink-0"
          aria-label="Previous screenshot"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        {/* Custom Phone Frame */}
        <div className="relative inline-block">
          {/* Phone body */}
          <div className="bg-base-300 rounded-[3rem] p-3 shadow-xl border-4 border-base-300">
            {/* Notch */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-6 bg-base-300 rounded-b-2xl z-10" />
            {/* Screen */}
            <div className="bg-black rounded-[2.25rem] overflow-hidden w-[280px]">
              <div
                className="flex transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {screenshots.map((screenshot, index) => (
                  <img
                    key={index}
                    src={screenshot.src}
                    alt={screenshot.alt}
                    className="w-[280px] flex-shrink-0 h-auto block"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Next Button */}
        <button
          onClick={goToNext}
          className="btn btn-circle btn-outline btn-sm flex-shrink-0"
          aria-label="Next screenshot"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Dot Indicators */}
      <div className="flex justify-center gap-2 mt-4">
        {screenshots.map((_, index) => (
          <button
            key={index}
            onClick={() => changeSlide(index)}
            className={`w-2 h-2 rounded-full transition-colors ${
              index === currentIndex ? 'bg-primary' : 'bg-base-300'
            }`}
            aria-label={`Go to screenshot ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ScreenshotCarousel;
